import useTranslation from 'next-translate/useTranslation';
import { RestrictionDetailsModalRestrictionsDetailsProps } from './props';
import styles from './styles.module.scss';
import RestrictionDetailsModalRestrictionsDetailsRenderer from './Renderer';
import { useCountdown } from '@starsoft/common/hooks';
import { useDispatch } from 'react-redux';
import { setUserRestrictions } from '@/lib/store/user-restrictions/actions';
import {
  Counter,
  FormGroup,
  TransWithDefault,
} from '@starsoft/common/components';
import { memo, useMemo } from 'react';
import RestrictionDetailsModalRestrictionsDetailsAmount from './Amount';
import RestrictionDetailsModalRestrictionsDetailsDuration from './Duration';
import RestrictionDetailsModalRestrictionsDetailsCategory from './Category';
function RestrictionDetailsModalRestrictionsDetails({
  restriction,
  userRestriction,
}: RestrictionDetailsModalRestrictionsDetailsProps) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const resolvedRestriction = useMemo(() => {
    return restriction ?? userRestriction.restriction;
  }, [restriction, userRestriction]);

  function handleCountdownComplete() {
    dispatch(setUserRestrictions(userRestriction));
  }

  const countdouwn = useCountdown({
    targetDate: new Date(userRestriction?.cycleEndAt ?? new Date()).toString(),
    disabled: !userRestriction?.cycleEndAt,
    onCountdownComplete: handleCountdownComplete,
  });

  return (
    <div className={styles.container}>
      <p className={styles.container__label}>
        {!!restriction && (
          <TransWithDefault
            i18nKey={`common:user_restrictions_unreachable`}
            values={{
              category: t(`account:${restriction?.categoryId}_category_label`),
            }}
          />
        )}
        {!!userRestriction &&
          t('restriction_details_label', {
            timeFrame: `${resolvedRestriction?.duration} ${t(`account:${resolvedRestriction?.frameId}_frame_label${resolvedRestriction?.duration > 1 ? '_plural' : ''}`)?.toLowerCase?.()}`,
            type: `${t(`account:${resolvedRestriction?.categoryId}_category_label`)?.toLowerCase?.()}`,
          })}
      </p>
      <div className={styles.container__wrapper}>
        <RestrictionDetailsModalRestrictionsDetailsAmount
          restriction={resolvedRestriction}
        />
        <RestrictionDetailsModalRestrictionsDetailsDuration
          restriction={resolvedRestriction}
        />
        <RestrictionDetailsModalRestrictionsDetailsCategory
          restriction={resolvedRestriction}
        />
        {!!userRestriction && (
          <RestrictionDetailsModalRestrictionsDetailsRenderer
            userRestriction={userRestriction}
            restriction={restriction}
          />
        )}
        {!!userRestriction?.cycleEndAt && (
          <FormGroup label={t('restriction_details_counter_label')} secondary>
            <Counter
              countdown={countdouwn}
              hideDays={countdouwn?.days === '00'}
              hideHours={countdouwn?.hours === '00'}
              isSmall
              isContainerColor
            />
          </FormGroup>
        )}
      </div>
    </div>
  );
}

export default memo(RestrictionDetailsModalRestrictionsDetails);
